import axios from 'axios';
import { useMutation } from 'react-query';

export type SignupFields = {
  spaceCode: string;
  firstName: string;
  lastName: string;
  email: string;
};

export const useSignup = () => {
  const mutation = useMutation<any, Error, SignupFields>((data) =>
    axios.post('signup', data)
  );

  return mutation;
};
